<template>
    <v-container fill-height class="align-start">
        <div class="row no-gutters" width="100%">
            <v-col>
                <v-toolbar class="elevation-0 mt-n3 row-full" height="relative">
                    <div class="container d-flex pb-3 pt-2 align-center">
                        <v-toolbar-title color="primary" class="headline font-weight-bold">Browse Products Categories</v-toolbar-title>
                    </div>

                    <template v-slot:extension>
                        <div class="container d-flex py-4">
                            <div style="width: 200px;">
                                <v-text-field
                                    single-line
                                    label="Search..."
                                    v-model="searchText"
                                    outline
                                    clearable
                                ></v-text-field>
                            </div>
                        </div>
                    </template>
                </v-toolbar>
                <loading-overlay :loading="loading"></loading-overlay>

                <!-- <p class="blue-grey--text lighten-4 caption mt-10">Found {{ ca.length }} transaction services</p> -->
                <v-container fluid>
                <v-data-iterator
                        :items="categories"
                        :items-per-page="pagination.ordersPerPage"
                        :page.sync="pagination.page"
                        hide-default-footer
                        :loading="loading"
                        @page-count="pagination.pageCount = $event"
                    >
                        <v-row>
                            <v-col
                                cols="12"
                                sm="6"
                                md="4"
                                lg="3"
                                v-for="category in categories"
                                :key="category.title"
                            >
                                <v-card
                                    shaped
                                    class="rounded-card mx-auto category py-4 mt-5 text-center"
                                    max-width="344"
                                    @click="$router.push(`/shopping/category/${category.title.split(' ').join('-').toLowerCase()}`)"
                                >
                                    <img :src="category.img" class="mb-3" height="150px" />
                                    <h3>{{ category.title }}</h3>
                                </v-card>
                            </v-col>

                            <template v-slot:footer>
                                <v-pagination
                                    v-model="pagination.page"
                                    :length="pagination.pageCount"
                                    :total-visible="7"
                                />
                            </template>
                        </v-row>
                    </v-data-iterator>
                </v-container>
            </v-col>
        </div>
    </v-container>
</template>

<script>
    export default {
        data,
        computed: getComputed(),
    }

    function data() {
        return {
            loading: false,
            pagination: {
                ordersPerPage: 5,
                page: 1,
                pageCount: 0,
            },
            searchText: '',
            categories: [
                {
                    title: 'Televisions',
                    img: 'https://www.decorhubng.com/wp-content/uploads/2018/05/tv_55k3110pw-1.jpg',
                },
                {
                    title: 'Washing Machines',
                    img: 'https://i.ebayimg.com/images/g/fWkAAOSwiEVecUTs/s-l500.jpg'
                },
                {
                    title: 'Furniture',
                    img: 'https://i.ebayimg.com/images/g/3GoAAOSw4fpcf8wv/s-l500.jpg',
                },
                {
                    title: 'Refrigerators',
                    img: 'https://images.homedepot-static.com/productImages/be986f37-2464-4b6f-8f4a-db63d88a1b9a/svn/stainless-steel-ge-top-freezer-refrigerators-gts19ksnrss-64_1000.jpg',
                },
                {
                    title: 'Inverters & Generators',
                    img: 'https://5.imimg.com/data5/JD/RS/MY-42169717/silent-diesel-canopy-set-500x500.jpg',
                },
                {
                    title: 'Gas Cookers',
                    img: 'https://images-na.ssl-images-amazon.com/images/I/61ZjFN5w7QL._AC_SX466_.jpg',
                },
                {
                    title: 'Air Conditioners',
                    img: 'https://i.ebayimg.com/images/g/u-8AAOSwopFfIaOL/s-l500.jpg'
                },
            ],
        }
    }

    function getComputed() {
        return {
            filteredCategories,
        }

        function filteredCategories() {
            return this.categories.filter(key => key.name.toLowerCase().includes(this.searchText.toLowerCase()));
        }
    }
</script>

<style scoped>
.category:hover {
    border: 1px solid #3F51B5;
    cursor: pointer;
    transition: 0.5s ease-in;
}
</style>
